"use client";

import Link from "next/link";
import { useEffect } from "react";

export default function HomeError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[home-error]", error);
  }, [error]);

  return (
    <section className="section" style={{ minHeight: "70vh", display: "grid", placeItems: "center" }}>
      <div className="container container--narrow" style={{ textAlign: "center" }}>
        <span className="mono" style={{ color: "var(--neon-aqua, #4DE8FF)", letterSpacing: "0.08em" }}>
          / erro {error.digest ?? ""}
        </span>
        <h1 className="display-2" style={{ marginTop: 20 }}>Falha ao carregar a home.</h1>
        <p className="lead" style={{ marginTop: 16 }}>
          Tivemos um problema ao montar esta página. Tente recarregar.
        </p>
        <div style={{ display: "inline-flex", gap: 12, marginTop: 28 }}>
          <button type="button" onClick={() => reset()} className="btn btn--primary">
            Tentar de novo
          </button>
          <Link className="btn btn--ghost" href="/servicos">Conhecer os serviços</Link>
        </div>
      </div>
    </section>
  );
}
